<template>
  <div class="pop">
    <div class="meet9ingnotice">
      <div class="row rowd" style="background:#333333">
        <Icon style="color:red;margin-right:10px;font-size:14px;" type="information-circled"></Icon>{{$t('m.PlsImproveTheInformation')}}
      </div>
      <div v-if="tab">
        <div class="row">
          <div class="left">{{$t('m.NameColon')}}</div>
          {{usermessage.name}}
        </div>
        <div class="row">
          <div class="left">{{$t('m.MobileColon')}}</div>
          {{usermessage.mobile}}
        </div>
        <div class="row">
          <div class="left">{{$t('m.EMailColon')}}</div>
          {{usermessage.email}}
        </div>
        <div @click="tab=!tab" class="button1 bgc">{{$t('m.Edit')}}</div>
        <div @click="exit" class="button2 bgc">{{$t('m.ExitSpace')}}</div>
      </div>
      <div v-if="!tab">
        <div class="row">
          <div class="left">{{$t('m.NameColon')}}</div>
          <input type="text" v-model="usermessage.name" />
        </div>
        <div class="row">
          <div class="left">{{$t('m.MobileColon')}}</div>
          <input type="text" v-model="usermessage.mobile" />
        </div>
        <div class="row">
          <div class="left">{{$t('m.EMailColon')}}</div>
          <input type="text" v-model="usermessage.email" />
        </div>
        <div @click="editusermessage()" class="button1 bgc">{{$t('m.SaveSpace')}}</div>
        <div @click="tab=!tab" class="button2 bgc">{{$t('m.CancelSpace')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import { editusermessage, usermessage } from "../../assets/js/url";

export default {
  name: "usermessage",
  data() {
    return {
      usermessage: Object,
      tab: true,
      uploadshow: true,
      imageurl: ""
    };
  },
  components: {
    Header
  },
  mounted() {
    this.getusermessage();
  },
  methods: {
    attendinit() {
      // 记录store归零，暂时不用
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfpartyname", "");
      this.$store.commit("setmeetingcfhost", "");
      this.$store.commit("setmeetingcfhostname", "");
      this.$store.commit("setmeetingcfterminal", "");
      this.$store.commit("setmeetingcfterminalname", "");
    },
    uploads(res) {
      this.$toast(this.$t('m.UploadOK'));
      this.imageurl = res.data.localpicpath.replace(
        /[a-z\/]*static/,
        "./static/"
      );
      this.uploadshow = false;
    },
    uploaderr(res) {
      this.$toast(this.$t('m.UploadFailSendAgain'));
    },
    getusermessage() {
      this.$http
        .post(usermessage, {
          useruuid: window.sessionStorage.getItem("UUID"),
          usertype: 2
        })
        .then(res => {
          this.usermessage = res.data.data;
        });
    },
    editusermessage() {
      this.usermessage.image = this.imageurl;
      const _this = this;
      this.$http.post(editusermessage, this.usermessage).then(res => {
        if (res.data.status == 2000) {
          this.tab = !this.tab;
        } else {
          this.$toast(`${res.data.data.errorDes}`);
        }
      });
    },
    closeallpop() {
      this.$emit("popclosemessage");
    },
    exit() {
      window.sessionStorage.clear("UUID");
      window.localStorage.removeItem("password");
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000000;
}

.meet9ingnotice {
  width: 3rem;
  height: 2.6rem;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.2rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.2rem;
  font-size: 0.14rem;
  line-height: 0.49rem;
  color: #666;
  background-color: #fff;
}

.row {
  height: 0.49rem;
  border-bottom: 1px solid #d7d5d5;
}

.rowd {
  margin: -0.2rem;
  margin-bottom: 0;
  border-radius: 8px 8px 0 0;
  line-height: 0.49rem;
  color: #fff;
  text-align: center;
}

.left {
  float: left;
  width: 0.5rem;
  text-align: center;
}

.warp {
  height: 2.37rem;
  padding: 0.1rem 0;
  text-align: center;
}

.content {
  line-height: 0.28rem;
  width: 1.7rem;
  float: left;
}

.button {
  width: 100%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: right;
  cursor: pointer;
}

.button1 {
  width: 45%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: left;
  cursor: pointer;
}

.button2 {
  width: 45%;
  height: 0.41rem;
  margin-top: 0.07rem;
  color: #fff;
  text-align: center;
  font-size: 0.15rem;
  border-radius: 3px;
  line-height: 0.41rem;
  float: right;
  cursor: pointer;
}

input {
  border: none;
  background-color: transparent;
  height: 0.35rem;
  outline: none;
  vertical-align: middle;
  line-height: 0.35rem;
}

.popclosex {
  position: absolute;
  top: 0rem;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/waitcheck.vue